var map = {
	"./a.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/a.ogg",
	"./aaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/aaa.ogg",
	"./ba.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ba.ogg",
	"./baaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/baaa.ogg",
	"./baaa_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/baaa_chandrabindu.ogg",
	"./bha_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/bha_chandrabindu.ogg",
	"./bhaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/bhaaa.ogg",
	"./bhaaa_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/bhaaa_chandrabindu.ogg",
	"./bhe.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/bhe.ogg",
	"./bi_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/bi_hraswo.ogg",
	"./bu_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/bu_hraswo.ogg",
	"./cha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/cha.ogg",
	"./chaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/chaa.ogg",
	"./chaaa_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/chaaa_chandrabindu.ogg",
	"./chandrabindu_au.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/chandrabindu_au.ogg",
	"./chara_chaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/chara_chaaa.ogg",
	"./chhaaata_chhaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/chhaaata_chhaaa.ogg",
	"./chii_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/chii_dirgha.ogg",
	"./damaha_da.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaha_da.ogg",
	"./damaha_daaa_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaha_daaa_chandrabindu.ogg",
	"./damaha_dee_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaha_dee_dirgha.ogg",
	"./damaha_hraswo_duu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaha_hraswo_duu.ogg",
	"./damaru_da.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaru_da.ogg",
	"./damaru_daaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaru_daaa.ogg",
	"./damaru_do.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/damaru_do.ogg",
	"./dhaan_dhaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/dhaan_dhaaa.ogg",
	"./dhakani_dhaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/dhakani_dhaaa.ogg",
	"./dhakani_dhah.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/dhakani_dhah.ogg",
	"./dhakani_dho.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/dhakani_dho.ogg",
	"./dirgha_mi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/dirgha_mi.ogg",
	"./dirgha_pee.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/dirgha_pee.ogg",
	"./ee_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ee_hraswo.ogg",
	"./eee_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/eee_dirgha.ogg",
	"./euta_ye.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/euta_ye.ogg",
	"./fuu_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/fuu_dirgha.ogg",
	"./ga.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ga.ogg",
	"./gaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/gaaa.ogg",
	"./gai_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/gai_chandrabindu.ogg",
	"./gey.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/gey.ogg",
	"./gho.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/gho.ogg",
	"./ghu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ghu.ogg",
	"./go.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/go.ogg",
	"./ha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ha.ogg",
	"./haaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/haaa.ogg",
	"./haaa_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/haaa_chandrabindu.ogg",
	"./hey.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hey.ogg",
	"./hraswo_chu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_chu.ogg",
	"./hraswo_hee.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_hee.ogg",
	"./hraswo_ni.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_ni.ogg",
	"./hraswo_nu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_nu.ogg",
	"./hraswo_pi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_pi.ogg",
	"./hraswo_sukrabar_su.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_sukrabar_su.ogg",
	"./hraswo_sundar_su.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/hraswo_sundar_su.ogg",
	"./ja.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ja.ogg",
	"./jaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/jaaa.ogg",
	"./jarayo_ja.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/jarayo_ja.ogg",
	"./jhola_jho.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/jhola_jho.ogg",
	"./ka.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ka.ogg",
	"./kaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/kaaa.ogg",
	"./kai_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/kai_chandrabindu.ogg",
	"./kha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/kha.ogg",
	"./khaaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/khaaa.ogg",
	"./khra_bakhra.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/khra_bakhra.ogg",
	"./khu_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/khu_hraswo.ogg",
	"./ki_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ki_hraswo.ogg",
	"./ko.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ko.ogg",
	"./kra.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/kra.ogg",
	"./ku_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ku_hraswo.ogg",
	"./la.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/la.ogg",
	"./laaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/laaa.ogg",
	"./lo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/lo.ogg",
	"./ma.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ma.ogg",
	"./maaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/maaa.ogg",
	"./mi_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/mi_hraswo.ogg",
	"./moto_sha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/moto_sha.ogg",
	"./mu_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/mu_hraswo.ogg",
	"./na.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/na.ogg",
	"./naaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/naaa.ogg",
	"./nee_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/nee_dirgha.ogg",
	"./ney.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ney.ogg",
	"./nga.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/nga.ogg",
	"./pa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/pa.ogg",
	"./paaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/paaa.ogg",
	"./pai.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/pai.ogg",
	"./patalo_saaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/patalo_saaa.ogg",
	"./patalo_see_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/patalo_see_dirgha.ogg",
	"./patalo_sha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/patalo_sha.ogg",
	"./pha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/pha.ogg",
	"./phey.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/phey.ogg",
	"./pho.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/pho.ogg",
	"./po.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/po.ogg",
	"./ra.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ra.ogg",
	"./raaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/raaa.ogg",
	"./ree_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ree_dirgha.ogg",
	"./rey.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/rey.ogg",
	"./ri_hraswo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ri_hraswo.ogg",
	"./ru.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ru.ogg",
	"./taa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/taa.ogg",
	"./tachandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tachandrabindu.ogg",
	"./tali_ta.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tali_ta.ogg",
	"./tali_taaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tali_taaa.ogg",
	"./tapari_ta.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tapari_ta.ogg",
	"./tapari_taaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tapari_taaa.ogg",
	"./tapari_tee_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tapari_tee_dirgha.ogg",
	"./tapari_tey.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tapari_tey.ogg",
	"./tapari_to.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/tapari_to.ogg",
	"./thadeuro_thee_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/thadeuro_thee_dirgha.ogg",
	"./thapadi_thee_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/thapadi_thee_dirgha.ogg",
	"./ti.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ti.ogg",
	"./ttee_hatti_dirgha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ttee_hatti_dirgha.ogg",
	"./waaa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/waaa.ogg",
	"./wu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/wu.ogg",
	"./wu_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/wu_chandrabindu.ogg",
	"./yaaa_chandrabindu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/yaaa_chandrabindu.ogg",
	"./ख.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/ख.ogg",
	"./पा_1.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/पा_1.ogg",
	"./रे_2.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/letters/रे_2.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Play/DragandDropPlay/audios/letters sync recursive ^\\.\\/.*$";